<template>
 
  <navBar></navBar>

  
  <router-view >
  </router-view>
  <foot/>
</template>
<script>
import {ref} from 'vue';
import foot from "./components/footer.vue";
import navBar from "./components/navBar.vue";
import { onMounted } from '@vue/runtime-core'
import AOS from "aos";
export default {
components:{foot,navBar},
  setup() {
             
   
         
  },
}
</script>
<style scoped>


</style>
